<template>
  <el-dialog
    title="请确认您的操作!"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose"
  >
    <div style="text-align: center;">
      <p>确定删除订单</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDeleteStoreOrderUpModel">点错了</el-button>
      <el-button type="primary" @click="deletStoreOrderUp">确认删除</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteStoreOrderUp } from '@/api/goods/deleteStoreOrderUpApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteStoreOrderUp',
  data() {
    return {
      dialogVisible: false,
      deleteStoreOrderUpInfo: {}
    }
  },
  methods: {
    open(params) {
      this.deleteStoreOrderUpInfo = params
      this.dialogVisible = true
    },
    async deletStoreOrderUp() {
      let shopId = await getShopId()
      this.deleteStoreOrderUpInfo.shopId = shopId
      
      deleteStoreOrderUp(this.deleteStoreOrderUpInfo).then(res => {
        if (res.code === 0) {
          this.$message.success(res.msg)
          this.dialogVisible = false
          this.$emit('storeOrderUpDeleted')
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.error('删除挂单失败:', err)
        this.$message.error('删除挂单失败')
      })
    },
    closeDeleteStoreOrderUpModel() {
      this.dialogVisible = false
    },
    handleClose(done) {
      this.closeDeleteStoreOrderUpModel()
      done()
    }
  }
}
</script>

<style scoped>
/* 可以添加自定义样式 */
</style>